<ng-container *translateBlock="let t">
  <label class="toggle-wrapper">
    <span class="toggle-label">
      @if (formData.iconLeft) {
        <span class="material-symbols-rounded icon">
          {{ formData.iconLeft }}
        </span>
      }

      {{ formData.isTranslated ? t(formData.label) : formData.label }}
    </span>

    <span class="toggle">
      <input type="checkbox"
             [readonly]="formData.readonly"
             [checked]="checked"
             [disabled]="formData.readonly"
             (change)="onToggle($event)"/>

      <span class="slider"></span>
    </span>
  </label>
</ng-container>
